Upload partner load file

<ul>
  <li>File type CSV</li>
  <li>Delimiter "," (comma)</li>
  <li>Text fields quoted with " (double quote)</li>
  <li>Columns <span style="font-family: monospace;">Token, Load amount, Currency, Description</span></li>
  <li>Header must be present</li>
  <li>Amounts to be formatted
    <ul>
      <li>with a . (dot) as decimal seperator</li>
      <li>no thousands seperator</li>
    </ul>

  </li>
</ul>


<app-file-upload *appHasRoles="['admin', 'partner', 'finance_manager']" (upload)="triggerOnUpload($event)"></app-file-upload>
